import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BadgePercent, Snowflake } from "lucide-react";

const AnnouncementBar = () => (
  <div
    data-testid="announcement-bar"
    className="fixed inset-x-0 top-0 z-[55] h-[var(--banner-h)] overflow-hidden bg-[#062B52]"
  >
    {/* decorative snow */}
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      {[4, 15, 26, 37, 63, 74, 85, 96].map((left, i) => (
        <Snowflake
          key={left}
          className="absolute text-white"
          strokeWidth={1.2}
          style={{
            left: `${left}%`,
            top: i % 2 === 0 ? "16%" : "54%",
            width: i % 3 === 0 ? 14 : 9,
            height: i % 3 === 0 ? 14 : 9,
            opacity: i % 3 === 0 ? 0.13 : 0.08,
          }}
        />
      ))}
    </div>
    <div className="pointer-events-none absolute left-1/2 top-0 h-full w-[520px] -translate-x-1/2 bg-[#0757B8]/25 blur-2xl" />

    {/* ---------- Desktop / Tablet: one centered row ---------- */}
    <div className="shell relative z-10 hidden h-full items-center justify-center gap-4 md:flex">
      <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-[#FF6B00] px-3 py-1">
        <BadgePercent className="h-3.5 w-3.5 text-white" />
        <span className="font-mono-label text-[9.5px] text-white">Nur für Gewerbekunden</span>
      </span>

      <p className="text-center text-[13px] leading-tight text-white">
        <span className="hidden xl:inline">Vom </span>
        <span className="font-semibold">01.10. bis 01.12.</span>
        <span className="hidden xl:inline"> profitieren Sie von</span>
        <span className="xl:hidden">:</span> bis zu{" "}
        <span className="font-bold text-[#FF6B00]">20 % Rabatt</span>
        <span className="hidden xl:inline"> auf unsere Preise.</span>
      </p>

      <Link
        to="/kontakt"
        data-testid="announcement-cta"
        className="btn btn-orange glow-accent h-[30px] shrink-0 gap-1.5 px-4 text-[11px] tracking-[0.08em]"
      >
        JETZT ANFRAGEN
        <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>

    {/* ---------- Mobile: centered stack ---------- */}
    <div className="relative z-10 flex h-full flex-col items-center justify-center gap-[3px] px-3 text-center md:hidden">
      <span className="flex items-center gap-1 rounded-full bg-[#FF6B00] px-2 py-[2px]">
        <BadgePercent className="h-[11px] w-[11px] text-white" />
        <span className="font-mono-label text-[8.5px] leading-none text-white">
          Nur für Gewerbekunden
        </span>
      </span>
      <p className="text-[11px] font-medium leading-tight text-white">
        Bis zu <span className="font-bold text-[#FF6B00]">20 % Rabatt</span> · 01.10.–01.12.
      </p>
      <Link
        to="/kontakt"
        data-testid="announcement-cta-mobile"
        className="btn btn-orange glow-accent h-[25px] gap-1 px-3.5 text-[9.5px] tracking-[0.1em]"
      >
        JETZT ANFRAGEN
        <ArrowRight className="h-3 w-3" />
      </Link>
    </div>
  </div>
);

export default AnnouncementBar;
